<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path opacity="0.9" fill-rule="evenodd" clip-rule="evenodd" d="M17.7279 33.6274L7.12132 23.0208L5 25.1421L16.3137 36.4558C17.0948 37.2369 18.3611 37.2369 19.1421 36.4558L42.4767 13.1213L40.3553 11L17.7279 33.6274Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
